module.exports = __webpack_public_path__ + "_assets/img/scan.719fcb5f.svg";